/**
 * Replaces all capital letters with a lowercase letter preceded by an underscore.
 * @param {string} s - The string to be converted.
 * @returns {string} A new string with the first letter of each word capitalized.
 */
// eslint-disable-next-line import/prefer-default-export
export const toSnakeFromCamel = (s) =>
  s.replace(/([A-Z])/g, (match, p1) => `_${p1.toLowerCase()}`)
